export default {
  API: {
    URL: process.env.REACT_APP_API
  },
  features: {
    recaptcha: true
  }
}
